import App from "@/App";
import { renderWithProviders } from "./render-with-providers";

export const renderApp = async () => {
  await renderWithProviders(<App />);
};
